export const TOAST = "TOAST";
export const BANNER = "BANNER";
